<template>
  <div class="ps_container">
    <div class="ps_header">
      <span class="heading-2">{{ $t("settings.profile.title") }}</span>
      <PrimaryButton :text="$t('settings.profile.save')" :loading="buttonLoading" @onClick="saveChanges" />
    </div>
    <v-divider class="ps_divider"></v-divider>
    <v-card outlined>
      <v-progress-linear v-if="loading" indeterminate color="primary" />
      <UploadHeader />
      <div class="ps_details">
        <span class="heading-4">{{ $t("settings.profile.personalDetails") }}</span>
        <v-row class="ps_row">
          <v-col cols="4" class="ps_input-group">
            <span>{{ $t("general.inputs.firstName") }}</span
            ><BaseInput v-model="firstName" :errors="firstNameErrors" fieldName="firstName" @blur="$v.email.$touch()"
          /></v-col>
          <v-col cols="4" class="ps_input-group">
            <span>{{ $t("general.inputs.lastName") }}</span
            ><BaseInput v-model="lastName" :errors="lastNameErrors" fieldName="lastName" @blur="$v.email.$touch()" />
          </v-col>
        </v-row>
      </div>
      <div class="ps_details">
        <span class="heading-4">{{ $t("settings.profile.accountDetails") }}</span>
        <v-row class="ps_row">
          <v-col cols="4" class="ps_input-group">
            <span>{{ $t("general.inputs.email") }}</span
            ><BaseInput
              v-model="email"
              :errors="emailErrors"
              fieldName="email"
              :disabled="true"
              @blur="$v.email.$touch()"
          /></v-col>
          <v-col cols="4" class="ps_input-group">
            <span>{{ $t("settings.language") }}</span>
            <Select v-model="locale" :items="languages" :label="$t('settings.selectLanguage')" />
          </v-col>
          <v-col cols="4" class="ps_input-group">
            <span>{{ $t("registrar.settings.timezone") }}</span>
            <BaseInput v-model="timeZone" :disabled="true" />
          </v-col>
        </v-row>
      </div>
      <ChangePassword />
    </v-card>
  </div>
</template>
<script>
import { email, required } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";

import ChangePassword from "@/components/settings/changePassword";
import UploadHeader from "@/components/settings/uploadHeader";
import BaseInput from "@/components/uikit/BaseInput";
import PrimaryButton from "@/components/uikit/PrimaryButton";
import Select from "@/components/uikit/Select";
import { snackBarEventBus, snackBarEventName } from "@/eventBuses/snackBar.eventBus";
import { LANGUAGES } from "@/utils/languages";

export default {
  name: "RegistrarSettings",
  components: {
    PrimaryButton,
    UploadHeader,
    BaseInput,
    Select,
    ChangePassword,
  },
  validations: {
    email: { required, email },
    firstName: { required },
    lastName: { required },
  },
  data: () => ({
    loading: false,
    buttonLoading: false,
    firstNameModel: "",
    lastNameModel: "",
    localeModel: "",
    emailModel: "",
    timeZoneModel: "",
    // form: {
    // },
    languages: LANGUAGES,
  }),
  computed: {
    ...mapGetters("profileSettings", ["registrarSettings", "avatar"]),
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push(this.$t("validation.email"));
      !this.$v.email.required &&
        errors.push(this.$t("validation.required", { field: this.$t("general.inputs.email") }));
      return errors;
    },
    firstNameErrors() {
      const errors = [];
      if (!this.$v.firstName.$dirty) return errors;
      !this.$v.firstName.required &&
        errors.push(this.$t("validation.required", { field: this.$t("general.inputs.firstName") }));
      return errors;
    },
    lastNameErrors() {
      const errors = [];
      if (!this.$v.lastName.$dirty) return errors;
      !this.$v.lastName.required &&
        errors.push(this.$t("validation.required", { field: this.$t("general.inputs.lastName") }));
      return errors;
    },
    firstName: {
      get() {
        return this.firstNameModel || this.registrarSettings.firstName;
      },
      set(v) {
        this.firstNameModel = v;
      },
    },
    lastName: {
      get() {
        return this.lastNameModel || this.registrarSettings.lastName;
      },
      set(v) {
        this.lastNameModel = v;
      },
    },
    email: {
      get() {
        return this.emailModel || this.registrarSettings.email;
      },
      set(v) {
        this.emailModel = v;
      },
    },
    locale: {
      get() {
        return this.localeModel || this.registrarSettings.locale;
      },
      set(v) {
        this.localeModel = v;
      },
    },
    timeZone: {
      get() {
        return this.timeZoneModel || this.registrarSettings.timeZone;
      },
      set(v) {
        this.timeZoneModel = v;
      },
    },
  },
  methods: {
    ...mapActions("profileSettings", ["getRegistrarSettings", "saveRegistrarChanges"]),
    async saveChanges() {
      this.$gtag.event("click", { method: "Save Registrar Settings" });
      this.buttonLoading = true;
      try {
        await this.saveRegistrarChanges({
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          locale: this.locale,
          timeZone: this.timeZone,
        });
        snackBarEventBus.$emit(snackBarEventName, {
          message: this.$t("settings.success"),
          type: "success",
        });
        this.$root.$i18n.locale = this.locale;
      } catch (err) {
        snackBarEventBus.$emit(snackBarEventName, {
          message: (err && err.response && err.response.data && err.response.data.message) || err,
          type: "error",
        });
      } finally {
        this.buttonLoading = false;
      }
    },
  },
};
</script>
